// Envoie un événement GA4 via le dataLayer. Le site ne définit pas window.gtag :
// la balise Google est chargée par GTM, qui lit les commandes poussées ici.
const GA4_ID = "G-56S80CGXBP";

export function track(name: string, params: Record<string, unknown> = {}) {
  try {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    const push = function (..._args: unknown[]) {
      // gtag.js n'accepte que l'objet `arguments`, pas un tableau.
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer!.push(arguments);
    };
    push("event", name, { send_to: GA4_ID, ...params });
  } catch { /* analytics indisponible */ }
}
